import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'

type NetworkFiltersProps = {
  filters: {
    status?: string
    minReferrals?: number
  }
  onFiltersChange: (filters: { status?: string; minReferrals?: number }) => void
}

export function NetworkFilters({ filters, onFiltersChange }: NetworkFiltersProps) {
  return (
    <div className="flex flex-wrap items-center gap-4 p-4 bg-muted/50 rounded-lg border">
      <div className="flex items-center gap-2">
        <label className="text-sm font-medium">Status:</label>
        <Select
          value={filters.status || 'active'}
          onValueChange={(value) => onFiltersChange({ ...filters, status: value })}
        >
          <SelectTrigger className="w-[140px]">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="active">Ativos</SelectItem>
            <SelectItem value="inactive">Inativos</SelectItem>
          </SelectContent>
        </Select>
      </div>

      <div className="flex items-center gap-2">
        <label className="text-sm font-medium">Mín. Indicações:</label>
        <Select
          value={String(filters.minReferrals ?? 1)}
          onValueChange={(value) => onFiltersChange({ ...filters, minReferrals: Number(value) })}
        >
          <SelectTrigger className="w-[140px]">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="1">1+ indicação</SelectItem>
            <SelectItem value="2">2+ indicações</SelectItem>
            <SelectItem value="5">5+ indicações</SelectItem>
            <SelectItem value="10">10+ indicações</SelectItem>
            <SelectItem value="20">20+ indicações</SelectItem>
          </SelectContent>
        </Select>
      </div>

      <div className="ml-auto text-sm text-muted-foreground">
        💡 Mostrando apenas membros com pelo menos {filters.minReferrals || 1} indicaç
        {filters.minReferrals === 1 ? 'ão' : 'ões'}
      </div>
    </div>
  )
}
